import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import Utils from 'EurestoFonction/Utils'

export default class Stars extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: props.data
    }
  }

  onClickStar = _ => {
    const newData = (this.props.data < 5 || this.props.data === undefined) && (this.props.data || 0) + 1 || 0
    this.setState({
      data: newData
    }, this.props.onClickStar && this.props.onClickStar(newData))

  }

  render () {
    const contact = this.props.contact
    let textColor = 'EurestoText'
    let colorContact = contact &&
      contact.entite === 1 && 'EurestoPrimary'
      || 'EurestoSecondary'
    if(this.props.actif === false) {
      //textColor = colorContact
      colorContact = 'EurestoError'
    }
    return (
      <Grid container spacing={0}
            style={Object.assign({ margin: 0, padding: 0 }, this.props.style || {})} direction={!this.props.inline && "row" || 'column'} justify="center"
            alignContent={'center'}
            alignItems="center">
        {
          !this.props.inline && [1, 2, 3, 4, 5].map(index => (
            <Grid item xs={2} style={{ margin: 0, padding: 0 }}>
              <IconButton key={'radium-' + index}
                          disabled={this.props.disabled || false} aria-hidden="true"
                          onClick={() => this.props.onClickStar(index)}>
                <i style={{}}
                   className={'fa ' + (this.props.data >= index ? `fa-star ${colorContact}` : `fa-star-o ${colorContact}`) + '--text'}/>
              </IconButton></Grid>
          ))
          || <IconButton style={{cursor: 'pointer'}} key={Utils.getRandomNumber()} disabled={this.props.disabled || false} aria-hidden="true" onClick={this.onClickStar}>
            <i className={`fa fa-star ${colorContact}--text`} style={{position: 'relative', fontSize: 30}}><span className={`${textColor}--text`} style={{position: 'absolute', fontSize: 15, left: 9.5, top: 8, fontWeight: 'bold'}}>{this.props.data || 0}</span></i>
          </IconButton>
        }
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/Stars.js